import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { formatPhone } from '@rad/utility/formatting';
import { MDASH } from '../../utility/constants';
const getVehicleDescriptions = (vehicles) => (vehicles || []).filter((x) => !!x && !!x.description).map((x) => x.description);
const formatVehicles = (vehicles) => {
    const descriptions = getVehicleDescriptions(vehicles);
    if (!descriptions.length) {
        return MDASH;
    }
    if (descriptions.length <= 2) {
        return descriptions.join(', ');
    }
    return `${descriptions.slice(0, 2).join(', ')} (+ ${descriptions.length - 2} more)`;
};
const getFullVehicleList = (vehicles) => getVehicleDescriptions(vehicles).join(', ');
export default React.forwardRef((props, ref) => {
    const clients = React.useMemo(() => ([...props.records].sort((a, b) => a.lastname.toLocaleLowerCase().localeCompare(b.lastname.toLocaleLowerCase())
        || a.firstname.toLocaleLowerCase().localeCompare(b.firstname.toLocaleLowerCase()))), [props.records]);
    React.useImperativeHandle(ref, () => ({
        getContent: () => ({
            headers: ['name', 'address', 'vehicle', 'phone', 'email'],
            records: clients.map((x) => {
                var _a, _b;
                const phone = ((_a = x.contacts.find((y) => y.kind === 'phone')) === null || _a === void 0 ? void 0 : _a.value) || '';
                const email = ((_b = x.contacts.find((y) => y.kind === 'email')) === null || _b === void 0 ? void 0 : _b.value) || '';
                return [
                    `${x.lastname}, ${x.firstname}`,
                    x.no_address ? '' : `${x.address} ${x.city}, ${x.state} ${x.zip}`,
                    getFullVehicleList(x.vehicles),
                    phone,
                    email,
                ];
            }),
        }),
    }), [clients]);
    return _jsx(_Fragment, { children: _jsxs("table", { className: "table table-striped w-100", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Name" }), _jsx("th", { children: "Address" }), _jsx("th", { children: "Vehicle" }), _jsx("th", { children: "Phone" }), _jsx("th", { children: "Email" })] }) }), _jsx("tbody", { children: clients.map((x) => {
                        var _a, _b;
                        const phone = ((_a = x.contacts.find((y) => y.kind === 'phone')) === null || _a === void 0 ? void 0 : _a.value) || '';
                        const email = ((_b = x.contacts.find((y) => y.kind === 'email')) === null || _b === void 0 ? void 0 : _b.value) || '';
                        return _jsxs("tr", { children: [_jsx("td", { children: _jsxs("a", { href: `#/clients/${x.id}`, children: [x.lastname, ", ", x.firstname] }) }), x.no_address ? _jsx("td", { children: MDASH }) : _jsxs("td", { children: [x.address, " ", x.city, ", ", x.state, " ", x.zip] }), _jsx("td", { style: { 'maxWidth': '300px' }, title: getFullVehicleList(x.vehicles), children: _jsx("span", { style: { 'display': 'block', 'overflow': 'hidden', 'textOverflow': 'ellipsis', 'whiteSpace': 'nowrap' }, children: formatVehicles(x.vehicles) }) }), _jsx("td", { children: phone ? formatPhone(phone) : MDASH }), _jsx("td", { children: email || MDASH })] }, x.id);
                    }) })] }) });
});
